const checkedAnswer = (question: any) => {
  let checkedAnswers = question.checkedAnswers
  let correctOpts = question.options.filter((o: any) => {
    if (o.isAnswer === true) {
      return o.option
    }
  })

  if (
    checkedAnswers &&
    correctOpts?.every((val: any) => checkedAnswers?.includes(val.option)) &&
    checkedAnswers?.length == correctOpts.length
  ) {
    return true
  } else {
    return false
  }
}

const getScoreBasedObjectiveCheckBoxTypeQuestion = (
  assessment_result: any,
): any => {
  let count = 0
  let correct = 0

  if (assessment_result) {
    assessment_result.questions_result.forEach((question: any) => {
      // if question isnt an objective question
      if (question.type !== 1 && question.type !== 4) {
        return
      }

      count++
      if (
        question.type === 1 &&
        question.options &&
        question.options[question.userAnswer] &&
        question.options[question.userAnswer].isAnswer
      ) {
        correct++
      }

      if (question.type === 4 && checkedAnswer(question)) {
        correct++
      }
    })

    console.log(count, correct)
    const score = (correct / count) * 100
    return {
      totalObjective: count,
      correctAnswers: correct,
      score: !isNaN(score) ? score : '',
    }
  } else {
    return null
  }
}

export const AssessmentNamespace = {
  getScoreBasedObjectiveCheckBoxTypeQuestion,
}
